(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gst-invoice-fields"] && !Shopify.designMode) return;
  try {
    const GSTIN_PATTERN = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/;

  function updateGstFields(container, shouldClear) {
    const checkbox = container.querySelector('[name="attributes[GST Invoice Required]"][type="checkbox"]');
    const details = container.querySelector('.gst-invoice-fields__details');
    const businessName = container.querySelector('[data-gst-business-name]');
    const gstin = container.querySelector('[data-gstin]');
    const error = container.querySelector('.gst-invoice-fields__error');
    const isRequested = checkbox.checked;

    checkbox.setAttribute('aria-expanded', String(isRequested));
    details.hidden = !isRequested;
    businessName.required = isRequested;
    gstin.required = isRequested;

    if (!isRequested && shouldClear) {
      businessName.value = '';
      gstin.value = '';
      gstin.removeAttribute('aria-invalid');
      error.hidden = true;
    }
  }

  function validateGstFields(container) {
    const checkbox = container.querySelector('[name="attributes[GST Invoice Required]"][type="checkbox"]');
    const businessName = container.querySelector('[data-gst-business-name]');
    const gstin = container.querySelector('[data-gstin]');
    const error = container.querySelector('.gst-invoice-fields__error');

    if (!checkbox.checked) return true;

    gstin.value = gstin.value.trim().toUpperCase();
    const gstinIsValid = GSTIN_PATTERN.test(gstin.value);
    gstin.setAttribute('aria-invalid', String(!gstinIsValid));
    error.hidden = gstinIsValid;

    if (!businessName.value.trim()) {
      businessName.focus();
      businessName.reportValidity();
      return false;
    }

    if (!gstinIsValid) {
      gstin.focus();
      gstin.reportValidity();
      return false;
    }

    return true;
  }

  document.addEventListener('change', (event) => {
    const checkbox = event.target.closest('[name="attributes[GST Invoice Required]"][type="checkbox"]');
    if (!checkbox) return;
    updateGstFields(checkbox.closest('[data-gst-invoice-fields]'), true);
  });

  document.addEventListener('input', (event) => {
    if (!event.target.matches('[data-gstin]')) return;
    event.target.value = event.target.value.toUpperCase().replace(/\s/g, '');
    event.target.removeAttribute('aria-invalid');
    event.target.closest('[data-gst-invoice-fields]').querySelector('.gst-invoice-fields__error').hidden = true;
  });

  document.addEventListener(
    'invalid',
    (event) => {
      if (!event.target.matches('[data-gstin]')) return;
      event.target.setAttribute('aria-invalid', 'true');
      event.target.closest('[data-gst-invoice-fields]').querySelector('.gst-invoice-fields__error').hidden = false;
    },
    true
  );

  document.addEventListener('submit', (event) => {
    const containers = document.querySelectorAll(`[data-gst-invoice-fields] [form="${event.target.id}"]`);
    if (!containers.length) return;
    const container = containers[0].closest('[data-gst-invoice-fields]');
    if (!validateGstFields(container)) event.preventDefault();
  });

  document.querySelectorAll('[data-gst-invoice-fields]').forEach((container) => updateGstFields(container, false));
  } catch(e) { console.error(e); }
})();

})();
